module.exports = __webpack_public_path__ + "static/img/kukai_footer_bg.a0d94df5.png";